var ImageHash = {};
function requireAll(r) {
  r.keys().forEach((key)=>{
    let hashKey = key.substring(2);
    ImageHash[hashKey] = r(`${key}`);
  });
}
requireAll(require.context('.?inline', true, /\.svg$/));

export default ImageHash;

